import { createContext, useContext } from "react";

/** "new": Story Manager items (set_chart, chart-previews). "old": api-service canvas items (binding/format PATCH). cs3 §2.0. */
export type StoryPath = "new" | "old";
const StoryPathContext = createContext<StoryPath>("old");
export const StoryPathProvider = StoryPathContext.Provider;
export const useStoryPath = (): StoryPath => useContext(StoryPathContext);
